import {
  DetailRefundResponse,
  FactoryUpdateOrderInput,
  GetOrderDetailBankpayment,
  GetOrderDetailData,
  PaymentDetails,
} from "services/interface";
import { numberFormat } from "utils/nuberFormat";
import {
  Alert,
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  Modal,
  Popconfirm,
  Row,
  Space,
  Tabs,
  Tag,
  Typography,
  message,
} from "antd";
import { InputRef } from "antd";

import styled from "@emotion/styled";
import { useGetTransportType } from "hooks/useMasterData";
import { useCallback, useEffect, useRef, useState } from "react";
import ModalPrintPurchaseOrder from "../ModalPrintPurchaseOrder";
import TrackingNumberPanel from 'components/OrderManage/TrackingNumberPanel';
import SelfTrackingPendingCard from "components/OrderManage/OrderPrepareShip/SelfTrackingPendingCard";
import SelfTrackingModal from "components/OrderManage/OrderPrepareShip/SelfTrackingModal";
import { orderUsesPlatformShippingLabel } from "components/OrderManage/OrderPrepareShip/prepareShipSelection";
import { SelfTrackingState, getSelfTrackingState } from "components/OrderManage/OrderPrepareShip/selfTracking";
import { checkShippingItems } from "services/ordersApi";
import ConfirmPaymentDetail from "./ConfirmPaymentDetail";
import TransportSeleect from "./TransportSeleect";
import PostalSelect from "./PostalSelect";
import {
  useConfirmManualPayment,
  useCancelOrder,
  useUpdateManualPayment,
  useUpdateOrderAdmin,
  useUpdateOrderComplete,
  useRevertManualOrder,
  useDetailRefundListQuery,
  useConfirmOrderShipped,
  useGetOrderDetail,
} from "hooks/useOrders";
import { getContactMethodName, isTruthyShipShop } from "utils/convertData";
import { isCanceledItemStatus } from "utils/orderStatus";
import PostalLabel from "./PostalLabel";
import TransportLabel from "./TransportLabel";
import { formatDate } from "utils/dateFormat";
import CancelOrderDialog from "../CancelOrderDialog";
import ConfirmPaymentLabel from "./ConfirmPaymentLabel";
import dayjs from "dayjs";
import { CopyOutlined, CrownOutlined, EditOutlined, FormOutlined, UndoOutlined } from "@ant-design/icons";
import DueDateOrderDialog from "../DueDateOrderDialog";
import CancelDetailLabel from "./CancelDetailLabel";
import PaymentRefundDetailList from "./PaymentRefundDetailList";
import { useQueryClient } from "@tanstack/react-query";
import CopyToClipboard from "react-copy-to-clipboard";
import ModalTaxInvoice from "../ModalTaxInvoice";
import UpdateTransportSeleect from "./UpdateTransportSeleect";
import { orderManualConfirm } from "config";
import ConfirmPaymentPromptpay from "./ConfirmPaymentPromptpay";
import TransportLocal from "./TransportLocal";
import UpdateTransportLocal from "./UpdateTransportLocal";
import { useAppSelector } from "store";
import { CodCreditInfoSingle } from "components/OrderManage/shared/CodCreditInfo";
import { COD_CREDIT_INFO_QUERY_KEY, CREDIT_BALANCE_QUERY_KEY, useFactoryCodCreditInfo } from "hooks/useFactoryCredit";
// import React, { useRef } from "react";

interface ModalOderDetailProps {
  item: GetOrderDetailData | undefined;
  open: boolean;
  onClose: () => void;
  childrenBank: React.ReactNode[];
  refetchData: () => void;
  statusPage?: string;
  refectShipped?: () => void;
  refetchPrepare?: () => void;
  isProductProblem?: boolean;
  refetchCancel?: () => void;
  showEditModal?: (order_id: string, ref_id: string) => void;
  refetchCredit?: () => void;
}

const ModalOderDetail = ({
  item,
  onClose,
  open,
  childrenBank,
  refetchData,
  statusPage,
  refectShipped,
  refetchPrepare,
  isProductProblem,
  refetchCancel,
  showEditModal,
  refetchCredit,
}: ModalOderDetailProps) => {
  const queryClient = useQueryClient();

  const copiedRef = useRef(false);

  const handleCopy = () => {
    copiedRef.current = true;
    message.success("Copied to clipboard");
  };

  const { mutate: confirmManualPayment } = useConfirmManualPayment();
  const { mutate: updateManualPayment } = useUpdateManualPayment();
  const { mutate: revertManualOrder } = useRevertManualOrder();
  const { mutate: cancelOrder } = useCancelOrder();
  const { mutate: updateOrderComplete } = useUpdateOrderComplete();
  const { mutate: updateOrder } = useUpdateOrderAdmin();
  const { mutate: confirmOrderShipped } = useConfirmOrderShipped();
  const { data: transportTypeData } = useGetTransportType();

  // COD: ก่อนยืนยันรับคำสั่งซื้อ ต้องเช็ควงเงินเครดิต COD ให้พอก่อน — ปุ่ม "ยืนยันคำสั่งซื้อ" default
  // เป็น disabled ไว้ก่อนจนกว่าจะตรวจสอบผ่าน (ระหว่างโหลด/ไม่พอ ก็ยัง disabled อยู่)
  const isCodAcceptCheck = statusPage === "new_order" && item?.order_payment_type === "COD";
  const { data: codCreditInfo, isLoading: codCreditLoading } = useFactoryCodCreditInfo(
    { orderId: item?.order_id ?? "" },
    { enabled: isCodAcceptCheck && !!item?.order_id }
  );
  const codCreditBlocksAccept =
    isCodAcceptCheck && (codCreditLoading || codCreditInfo?.sufficient !== true);

  // --- forceRefreshOrderPayment: อัปเดต paid_amt / payment_status จาก webhook โดยตรงใน modal ---
  // ย้ายมาจาก OrderTableList เพราะ showDetail ของ instance นั้นไม่ตรงกับ instance ที่ modal เปิดอยู่
  const factory_id = useAppSelector(
    (state) => state.auth.profile?.user?.role?.ref_id || state.auth.contact?.id
  );
  const { mutate: mutatePaymentDetail } = useGetOrderDetail();
  const [paymentOverride, setPaymentOverride] = useState<{
    paid_amt?: number;
    payment_status?: string;
    payment_amount?: number;
  } | null>(null);

  // reset override ทุกครั้งที่เปิด modal order ใหม่
  useEffect(() => {
    setPaymentOverride(null);
  }, [item?.order_id]);

  // ใช้ยอดจาก list (vw_order.payment_amount = paid_amt) เป็นหลัก — ตรงกับค่าที่โชว์หลังกด refresh
  // ไม่ regress ลง 0 ถ้า getOrderDetail ยังคืน paid_amt เก่า
  const applyPaymentOverride = useCallback(
    (nextPaid: number, nextStatus?: string) => {
      if (!Number.isFinite(nextPaid)) return;
      setPaymentOverride((prev) => {
        const current = Number(
          prev?.payment_amount ?? prev?.paid_amt ?? item?.paid_amt ?? item?.payment_amount ?? 0
        );
        const statusChanged = !!nextStatus && nextStatus !== (prev?.payment_status ?? item?.payment_status);
        const paid = statusChanged ? nextPaid : Math.max(nextPaid, current);
        const status = nextStatus ?? prev?.payment_status ?? item?.payment_status;
        if (prev && paid === current && status === prev.payment_status) return prev;
        console.log("[ModalOrderDetail] apply payment override | paid:", paid, "| status:", status);
        return { paid_amt: paid, payment_amount: paid, payment_status: status };
      });
    },
    [item?.paid_amt, item?.payment_amount, item?.payment_status]
  );

  const syncPaidFromOrderListCache = useCallback(() => {
    if (!item?.order_id) return false;
    const queries = queryClient.getQueriesData({ queryKey: ["orderDataNewOrder"] });
    for (const [, response] of queries) {
      const payload = response as { data?: { order_data?: Array<{ order_id: string; payment_amount?: number; payment_status?: string }> }; order_data?: Array<{ order_id: string; payment_amount?: number; payment_status?: string }> } | undefined;
      const orderData = payload?.data?.order_data ?? payload?.order_data;
      const found = orderData?.find((row) => row.order_id === item.order_id);
      if (found && found.payment_amount != null) {
        applyPaymentOverride(Number(found.payment_amount), found.payment_status);
        return true;
      }
    }
    return false;
  }, [applyPaymentOverride, item?.order_id, queryClient]);

  // list refetch จบเมื่อไหร่ (ทุกแท็บใช้ queryKey เดียวกัน) → อัปเดตยอดชำระเงินรวมทันที
  useEffect(() => {
    if (!open || !item?.order_id) return;
    syncPaidFromOrderListCache();
    const unsubscribe = queryClient.getQueryCache().subscribe((event) => {
      const key = event?.query?.queryKey;
      if (Array.isArray(key) && key[0] === "orderDataNewOrder") {
        syncPaidFromOrderListCache();
      }
    });
    return unsubscribe;
  }, [open, item?.order_id, queryClient, syncPaidFromOrderListCache]);

  // รับ event จาก WebSocket handler → อ่านยอดจาก list cache + refetch detail
  useEffect(() => {
    const handleRefreshPayment = () => {
      if (!open || !item?.order_id) return;
      syncPaidFromOrderListCache();
      if (!factory_id) {
        console.warn("[ModalOrderDetail] skip getOrderDetail payment refresh: missing factory_id");
        return;
      }
      mutatePaymentDetail(
        { key_type: "order_id", group_by: "factory", items: [item.order_id], factory_id },
        {
          onSuccess: (freshData) => {
            const fresh = freshData?.data?.[0];
            if (fresh) {
              console.log("[ModalOrderDetail] payment refreshed | paid_amt:", fresh.paid_amt, "| status:", fresh.payment_status);
              const fromDetail = Math.max(
                Number(fresh.paid_amt ?? 0),
                Number(fresh.payment_amount ?? 0)
              );
              applyPaymentOverride(fromDetail, fresh.payment_status);
              syncPaidFromOrderListCache();
            }
          },
          onError: (err) => console.error("[ModalOrderDetail] payment refresh error:", err),
        }
      );
    };
    window.addEventListener("forceRefreshOrderPayment", handleRefreshPayment);
    return () => window.removeEventListener("forceRefreshOrderPayment", handleRefreshPayment);
  }, [open, item?.order_id, factory_id, mutatePaymentDetail, applyPaymentOverride, syncPaidFromOrderListCache]);
  // --- end forceRefreshOrderPayment ---

  const [cancel, setCancel] = useState(false);
  const [due, setDue] = useState(false);
  const [openTax, setOpenTax] = useState(false);
  const [isAllTrackingComplete, setIsAllTrackingComplete] = useState(false);
  const [isAllTrackingPrinted, setIsAllTrackingPrinted] = useState(false);

  const [dataPaymentItems, setDataPaymentItems] = useState<
    GetOrderDetailBankpayment[]
  >([]);
  const [dataPartialItems, setDataPartialItems] = useState<
    GetOrderDetailBankpayment[]
  >([]);
  const [refundList, setRefundList] = useState<DetailRefundResponse>();


  const [transportText, setTransportText] = useState<string>("");
  const [memo, setMemo] = useState<string>("");
  const [dueDate, setDueDate] = useState<string>("");
  const [discountPrice, setDiscountPrice] = useState<number>(0);
  const [isAdmin, setIsAdmin] = useState<boolean>(false);
  const [factoryId, setFactoryId] = useState<string>("");

  const [buttonClicked, setButtonClicked] = useState("");

  const [form] = Form.useForm();
  // Refs for payment_amount inputs
  const paymentAmountRefs = useRef<(InputRef | null)[]>([]);
  // const [formPayment] = Form.useForm();
  const [formCancel] = Form.useForm();
  const [formTransport] = Form.useForm();
  const [formPostal] = Form.useForm();
  const [formDueDate] = Form.useForm();
  const userDataProfile = useAppSelector((state) => state.auth.profile);
  const contactData = useAppSelector((state) => state.auth.contact);

  const use_platform_transport = contactData?.use_platform_transport;
  const isAppAgent = item?.datasource === "app_agent" || item?.datasource === "ecommerce_web";
  /** แท็บสำเร็จ + รับที่จุดขาย — ไม่แสดง Tracking / label ขนส่งด้านล่าง */
  const hideCompletedShipShopShippingUi =
    statusPage === "completed" && !!item && isTruthyShipShop(item);
  /** รับที่จุดขาย — แสดงชื่อ/เบอร์จาก ref แทนที่อยู่จัดส่ง และซ่อนที่อยู่/จุดจอด/หมายเหตุ */
  const shipShopRecipientDisplay = !!item && isTruthyShipShop(item);
  /** แถบเตรียมจัดส่ง + ship shop — ไม่แสดง TrackingNumberPanel / renderTransportLabel */
  const hidePrepareShipShopTrackingPanel =
    statusPage === "prepare_ship" && shipShopRecipientDisplay;

  // แถบเตรียมจัดส่ง: ชิ้น "ส่งเอง" ที่ยังไม่มีเลขพัสดุ กรอก Tracking ได้จากหน้ารายละเอียดเลย
  // (POST /order-tracks/self-tracking ใช้ได้ทั้งก่อนและหลังเรียกขนส่ง)
  const canSelfTrackInDetail =
    statusPage === "prepare_ship" && !!item && orderUsesPlatformShippingLabel(item);
  const [selfTrackingState, setSelfTrackingState] = useState<SelfTrackingState | undefined>();
  const [showSelfTracking, setShowSelfTracking] = useState(false);
  // รายละเอียดสินค้าของชิ้นที่ค้าง — null pendingItems (backend เก่า) = ทุกชิ้น factory_approve (ส่งเองล้วน)
  const selfPendingDetailItems = !selfTrackingState?.pending
    ? []
    : (item?.items || []).filter((it) =>
        selfTrackingState.pendingItems
          ? selfTrackingState.pendingItems.some((p) => p.retail_order_item_id === it.order_item_id)
          : it.item_status === "factory_approve"
      );
  const loadSelfTrackingState = useCallback(() => {
    if (!canSelfTrackInDetail || !item?.order_id) {
      setSelfTrackingState(undefined);
      return;
    }
    const orderId = item.order_id;
    checkShippingItems([orderId])
      .then((res) => {
        const d = res.status === "success" ? res.data?.details?.find((x) => x.order_id === orderId) : undefined;
        setSelfTrackingState(d ? getSelfTrackingState({ y: d.y ?? 0, z: d.z ?? 0, items: d.items }) : undefined);
      })
      .catch((e) => console.error("checkShippingItems error (order detail)", e));
  }, [canSelfTrackInDetail, item?.order_id]);

  useEffect(() => {
    if (open) loadSelfTrackingState();
    else setSelfTrackingState(undefined);
  }, [open, loadSelfTrackingState]);
  console.log('isAppAgent', isAppAgent)

  const { data: refundData } = useDetailRefundListQuery(item?.order_id ?? '', !!item?.order_id);

  const [refund_amount, setRefund_amount] = useState<number>(0);

  useEffect(() => {
    console.log('contactData999', contactData);
  }, [contactData]);

  const totalPriceOriginal =
    item?.items.reduce((acc, cur) => {
      if (item?.ref_source === "retail") {
        return acc + cur.wholesale_price * cur.sku_cnt;
      } else {
        return acc + cur.sku_price * cur.sku_cnt;
      }
    }, 0) ?? 0;

  //   //
  // const totalPricePrivilege = item?.order_is_vip
  //   ? item?.items.reduce((acc, cur) => acc + cur.sku_cnt * cur.wholesale_price, 0) ??
  //     0
  //   : 0;

  //640
  const totalPrice =
    item?.items.reduce((acc, cur) => acc + cur.total_price, 0) ?? 0;

  //-40
  const totalPricePrivilege = item?.order_is_vip
    ? totalPriceOriginal - totalPrice
    : 0;

  /** ยอดรวมสินค้า — ใช้ total_order_price จาก backend (ผลรวมค่าสินค้าอย่างเดียว ไม่รวมค่าส่ง
   * และตัดรายการที่ถูกยกเลิกออกแล้ว) แทนการ reduce จาก items เอง */
  const totalOrderPrice = item?.total_order_price ?? totalPriceOriginal;

  /** ค่าจัดส่ง — ใช้ total_transport_amount จาก backend (ผลรวมค่าส่งของทุกรายการในออเดอร์)
   * แทน transport_price ที่เป็นค่าส่งต่อรายการ */
  const totalTransportAmount = item?.transport_price ?? 0;

  //690
  const resultPrice =
    totalPrice + (item?.transport_price ?? 0) - (item?.discount_amount ?? 0);
  /** ยอดรวมทั้งหมด — ใช้ total_amount_price จาก backend (ค่าสินค้า + ค่าขนส่ง ยังไม่หักส่วนลด) */
  const totalAmountPrice = item?.total_amount_price ?? resultPrice;
console.log('resultPrice', resultPrice);
console.log('totalPrice', totalPrice);
console.log('item.transport_price', item?.transport_price);
console.log('item.discount_amount', item?.discount_amount);
console.log('item.order_is_vip', item?.order_is_vip);
console.log('item.extra_discount_amount', item?.extra_discount_amount);
  // const totalPrice =
  //   totalPriceOriginal +
  //   (item?.transport_price ?? 0) -
  //   (discountPrice +
  //     (item?.order_is_vip ? totalPriceOriginal - totalPricePrivilege : 0));

  // const totalPayment = item?.payment_amount || 0;

  // ค่าล่าสุดจาก forceRefreshOrderPayment (override จาก WebSocket) หรือจาก prop ตามปกติ
  const effectivePaidAmt = paymentOverride?.paid_amt ?? item?.paid_amt;
  const effectivePaymentStatus = paymentOverride?.payment_status ?? item?.payment_status;

  // COD: ใช้ paid_amt (ยอดเก็บ COD ได้จริงสะสม, recompute ทุก webhook ฝั่ง backend) แทน bank_payment
  // เพราะ COD ไม่มีการโอนเงินแบบ manual — เดิมใช้ bank_payment เท่านั้นทำให้ยอดไม่ขยับตาม webhook
  // เก็บเงิน COD สำเร็จเลย (ค้างแสดงเป็นยอดเต็มตลอด ไม่ว่าจะเก็บเงินได้แล้วหรือไม่)
  const totalPayment =
    item?.order_payment_type === "COD"
      ? (effectivePaidAmt ?? 0)
      : item?.bank_payment.reduce((acc, cur) => acc + cur.pay_amount, 0) ?? 0;

  

  // รับที่จุดขาย (ship shop) — หัก discount_amount ออกจากยอดชำระและคำนวณชำระเงินเกินใหม่
  const shipShopDiscount = 0;
  // ยอดชำระเงินรวม: ใช้ override จาก webhook/list ก่อน แล้วค่อย paid_amt / payment_amount ตอนเปิด modal
  // (เดิม COD อ่านแค่ paid_amt จาก getOrderDetail, ประเภทอื่นอ่านแค่ item.payment_amount ที่ไม่ถูกอัปเดต)
  // 2026-08-28: เดิมอ่าน item?.paid_amt ตรงๆ ไม่ผ่าน effectivePaidAmt เลย — ทำให้ "ยอดชำระเงินรวม" /
  // "ยอดเงินคงเหลือที่ต้องชำระ" ที่แถบ "ระหว่างจัดส่ง"/"เครดิตรอชำระ" ไม่ขยับตาม webhook เหมือนที่ totalPayment
  // (COD) แก้ไปแล้วก่อนหน้า — ใช้ effectivePaidAmt ให้เหมือนกันทุกจุด

  const displayPaymentAmount = effectivePaidAmt || 0;

  const remainingAmount = (
     (item?.net_paid_amount || 0) - (effectivePaidAmt || 0)
  ).toFixed(2);

  const OpenDue = () => {
    setDue(true);
  };
  const closeDue = () => {
    setDue(false);
  };
  const OpenCancel = () => {
    setCancel(true);
  };

  const closeCancel = () => {
    setCancel(false);
  };

  useEffect(() => {
    // sort bank_id = null ไว้ด้านบน
    const sortedData = item?.bank_payment.sort((a, b) => {
      if (a.bank_id === null) return -1;
      if (b.bank_id === null) return 1;
      return 0;
    });

    setDataPaymentItems(sortedData ?? []);
  }, [item?.bank_payment]);

  useEffect(() => {
    if (item && isTruthyShipShop(item)) {
      setTransportText("ลูกค้ารับสินค้า ณ จุดจำหน่ายสินค้า");
    } else if (transportTypeData) {
      const transport = transportTypeData.find(
        (i) => i.key === item?.transport_type
      );
      setTransportText(
        transport?.name ? transport.name : item?.transport_type || ""
      );
    } else {
      setTransportText(item?.transport_type || "");
    }
    setMemo(item?.order_memo || "");
    setDueDate(item?.due_date || "");
    setDiscountPrice(
      (item?.discount_amount || 0) + (item?.order_is_vip ? item?.extra_discount_amount || 0 : 0)
    );
  }, [transportTypeData, item]);
  

  const addPartialButtonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (dataPartialItems.length > 0 && addPartialButtonRef.current) {
      addPartialButtonRef.current.focus();
      addPartialButtonRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [dataPartialItems]);

  const addPaymentButtonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (dataPaymentItems.length > 0 && addPaymentButtonRef.current) {
      addPaymentButtonRef.current.focus();
      addPaymentButtonRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [dataPaymentItems]);

  useEffect(() => {
    if (userDataProfile?.user?.role?.ref_type === 'admin') {
      setIsAdmin(true);
    } else {
      setIsAdmin(false);
    }
  }, [userDataProfile]);

  useEffect(() => {
    if (contactData?.id) {
      setFactoryId(contactData?.id);
    }
  }, [contactData]);

  const onFinish = async (values: any) => {
    // ตรวจสอบ payment_amount ทุก index ที่เกี่ยวข้อง
    const paymentAmountKeys = Object.keys(values).filter((k) =>
      k.startsWith("payment_amount[")
    );
    let hasInvalid = false;
    let firstInvalidIndex: number = -1;
    for (let i = 0; i < paymentAmountKeys.length; i++) {
      const key = paymentAmountKeys[i];
      const val = values[key];
      if (val === undefined || val === null || val === "" || val === 0) {
        hasInvalid = true;
        firstInvalidIndex = i;
        break;
      }
    }
    if (hasInvalid) {
      await form.validateFields(paymentAmountKeys);
      // scroll และ focus ที่ input ตัวแรกที่ไม่ผ่าน
      if (
        firstInvalidIndex > -1 &&
        paymentAmountRefs.current[firstInvalidIndex]
      ) {
        setTimeout(() => {
          const inputDom = paymentAmountRefs.current[firstInvalidIndex]?.input;
          if (inputDom) {
            inputDom.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
            inputDom.focus();
          }
        }, 200);
      }
      message.error("กรุณาระบุจำนวนเงินที่โอนให้ถูกต้อง");
      setButtonClicked("");
      return;
    }

    const paymentRawData: PaymentDetails[] = [];

    Object.entries(values).forEach(([key, value]) => {
      let newItem: PaymentDetails;
      const regexResult = key.match(/\[(.*?)\]/);
      if (regexResult) {
        const index = regexResult[1];
        const existingItem = paymentRawData.find(
          (item) => item.tempId === index
        );

        if (existingItem) {
          if (key.includes("bank_id")) existingItem.bank_id = value as string;
          else if (key.includes("payment_date"))
            existingItem.payment_date = value as string;
          else if (key.includes("payment_amount"))
            existingItem.amount = value as number;
          else if (key.includes("image_slip"))
            existingItem.image_slip = value as string;
        } else {
          newItem = {
            tempId: index,
            bank_id: key.includes("bank_id") ? (value as string) : "",
            payment_date: key.includes("payment_date")
              ? dayjs(value as string)
                .locale("th")
                .format("YYYY-MM-DD HH:mm")
              : "",
            amount: key.includes("payment_amount") ? (value as number) : 0,
            image_slip: key.includes("image_slip") ? (value as string) : "",
          };
          paymentRawData.push(newItem);
        }
      }
    });

    const newData = {
      order_id: item?.order_id ?? "",
      process: "confirm_order",
      memo: memo,
      payment_list: paymentRawData.map((data) => {
        const imageSlip =
          typeof data.image_slip === "string"
            ? data.image_slip
            : ((data.image_slip as any[]) || [])[0]?.url || "";
        if (data.tempId && data.tempId.length <= 5) {
          return {
            bank_id: data.bank_id,
            image_slip: imageSlip,
            payment_date: dayjs(data.payment_date)
              .locale("th")
              .format("YYYY-MM-DD HH:mm"),
            amount: data.amount,
          };
        } else {
          return {
            id: data.tempId,
            bank_id: data.bank_id,
            image_slip: imageSlip,
            payment_date: dayjs(data.payment_date)
              .locale("th")
              .format("YYYY-MM-DD HH:mm"),
            amount: data.amount,
          };
        }
      }),
    };

    if (buttonClicked === "confirm_order") {
      confirmManualPayment(newData, {
        onSuccess: (res) => {
          if (res.status === "success") {
            message.success(`ยืนยันคำสั่งซื้อสำเร็จ`);
            refetchData();
            onClose();
            form.resetFields();
            // refetchPrepare && refetchPrepare();
            // refectShipped && refectShipped();
            // refetchCredit && refetchCredit();
            setFormValues({});

            queryClient.refetchQueries({
              queryKey: ["orderDataNewOrder"],
              type: "active",
            });
          } else {
            message.error(`ยืนยันคำสั่งซื้อไม่สำเร็จ กรุณาตรวจสอบข้อมูล`);
            console.log(res.error_message);
          }
        },
        onError: (error) => {
          message.error(`ยืนยันคำสั่งซื้อไม่สำเร็จ กรุณาตรวจสอบข้อมูล`);
          console.log(error.message);
        },
      });
    } else if (buttonClicked === "add_payment") {
      updateManualPayment(newData, {
        onSuccess: (res) => {
          if (res.status === "success") {
            message.success(`ยืนยันการโอนเงินสำเร็จ`);
            refetchData();
            refetchPrepare && refetchPrepare();
            refetchCredit && refetchCredit();
            refectShipped && refectShipped();
            onClose();
            form.resetFields();
            setFormValues({});
          } else {
            message.error(`ยืนยันการโอนเงินไม่สำเร็จ กรุณาตรวจสอบข้อมูล`);
            console.log(res.error_message);
          }
        },
        onError: (error) => {
          message.error(`ยืนยันการโอนเงินไม่สำเร็จ กรุณาตรวจสอบข้อมูล`);
          console.log(error.message);
        },
      });
    }

    setButtonClicked("");
  };

  const clearForm = () => {
    setFormValues({});
    form.resetFields();
    formCancel.resetFields();
  };

  const onFinishDueDate = (values: any) => {
    console.log(values);
    let updateOrderInput: FactoryUpdateOrderInput = {
      order_id: item?.order_id ?? "",
      due_date: dayjs(values.due_date).format("YYYY-MM-DD"),
    };
    updateOrder(updateOrderInput, {
      onSuccess: async (res) => {
        if (res.status === "success") {
          message.success("แก้ไขวันที่ต้องส่งสินค้าสำเร็จ");
          setDueDate(dayjs(values.due_date).format("YYYY-MM-DD"));
          await queryClient.refetchQueries({
            queryKey: ["orderDataNewOrder"],
            type: "active",
          });
          closeDue();
        } else {
          message.error(
            `แก้ไขวันที่ต้องส่งสินค้าไม่สำเร็จ: ${res.error_message}`
          );
        }
      },
      onError: (error) => {
        message.error(`แก้ไขวันที่ต้องส่งสินค้าไม่สำเร็จ: ${error.message}`);
      },
    });
  };
  const onFinishCancel = (values: any) => {
    cancelOrder(
      {
        order_id: item?.order_id ?? "",
        reason_id: values?.reason_id,
      },
      {
        onSuccess: (res) => {
          if (res.status === "success") {
            message.success("ยกเลิกคำสั่งซื้อสำเร็จ");
            onClose();
            closeCancel();
            refetchData();
            refetchCancel && refetchCancel();
            queryClient.refetchQueries({ queryKey: [COD_CREDIT_INFO_QUERY_KEY] });
            queryClient.refetchQueries({ queryKey: [CREDIT_BALANCE_QUERY_KEY] });
            formCancel.resetFields();
          } else {
            message.error(`ยกเลิกคำสั่งซื้อไม่สำเร็จ: ${res.error_message}`);
          }
        },
        onError: (error) => {
          message.error(`ยกเลิกคำสั่งซื้อไม่สำเร็จ: ${error.message}`);
        },
      }
    );
  };

  const handleRevertManualOrder = () => {
    let itemNew: string[] = [];
    itemNew = item?.items.map((item) => item.order_item_id) ?? [];
    revertManualOrder({
      factory_id: factoryId,
      items: itemNew,
    }, {
      onSuccess: (res) => {
        refetchData();
        onClose();
        message.success('คืนค่าคำสั่งซื้อสำเร็จ');
      },
      onError: (error) => {
        message.error(`คืนค่าคำสั่งซื้อไม่สำเร็จ: ${error.message}`);
      },
    });
  };

  const [formValues, setFormValues] = useState<any>({});

  // const handleButtonClick = () => {
  //   console.log("Form values:", formValues);

  //   // setFormValues((prevValues: any) => ({
  //   //   ...prevValues,
  //   //   bank_id_0: "3cccb5c6-001f-4b6c-8b34-ad495e2d2150",
  //   // }));
  //   // ทำอย่างอื่นตามต้องการ เช่น ส่งค่าไป API หรือทำการประมวลผลต่อไป
  // };

  const handleRemovePaymentItem = (index: number) => {
    const updatedItems = dataPaymentItems.filter((_, i) => i !== index);
    setDataPaymentItems(updatedItems);
  };

  const handleRemovePartialItem = (index: number) => {
    const updatedItems = dataPartialItems.filter((_, i) => i !== index);
    setDataPartialItems(updatedItems);
  };

  const handleDiscountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseFloat(e.target.value);
    setDiscountPrice(value);
  };

  useEffect(() => {
    if(refundData){
     //sum refund amount
      const totalRefundAmount = refundData.data.reduce((acc, cur) => acc + (cur.paid_amt || 0), 0);
      setRefundList(refundData);
      setRefund_amount(totalRefundAmount);
    }
  }, [refundData]);

  const renderTransportLabel = (status: string, item: GetOrderDetailData) => {
    switch (status) {
      case "post_office":
        return statusPage === "prepare_ship" ? (
          <PostalSelect
            formPostal={formPostal}
            item={item}
            refetchData={refetchData}
            refectShipped={refectShipped}
            onClose={onClose}
            memo={memo}
          />
        ) : (
          <PostalLabel
            formPostal={formPostal}
            item={item}
            refetchData={refetchData}
            refectShipped={refectShipped}
            onClose={onClose}
          />
        );

      case "pick_up_yourself": {
        return statusPage === "prepare_ship" ? (
          <TransportLocal
            formTransport={formTransport}
            item={item}
            refetchData={refetchData}
            refectShipped={refectShipped}
            statusPage={statusPage}
            onClose={onClose}
            memo={memo}
          />
        ) : (
          <>
            {statusPage === "shipped" ? (
              <>
                <UpdateTransportLocal
                  formTransport={formTransport}
                  item={item}
                  refetchData={refetchData}
                  refectShipped={refectShipped}
                  statusPage={statusPage}
                  onClose={onClose}
                  memo={memo}
                />
              </>
            ) : (
              <></>
            )}
          </>
        );
      }

      case "taxi":
        return statusPage === "prepare_ship" ? (
          <PostalSelect
            formPostal={formPostal}
            item={item}
            refetchData={refetchData}
            refectShipped={refectShipped}
            onClose={onClose}
            memo={memo}
          />
        ) : (
          <>
            {statusPage === "shipped" ? (
              <>
                <PostalLabel
                  formPostal={formPostal}
                  item={item}
                  refetchData={refetchData}
                  refectShipped={refectShipped}
                  onClose={onClose}
                />
              </>
            ) : (
              <></>
            )}
          </>
        );

      default: {
        return statusPage === "prepare_ship" ? (
          <TransportSeleect
            formTransport={formTransport}
            item={item}
            refetchData={refetchData}
            refectShipped={refectShipped}
            statusPage={statusPage}
            onClose={onClose}
            memo={memo}
          />
        ) : (
          <>
            {statusPage === "shipped" ? (
              <>
                <UpdateTransportSeleect
                  formTransport={formTransport}
                  item={item}
                  refetchData={refetchData}
                  refectShipped={refectShipped}
                  statusPage={statusPage}
                  onClose={onClose}
                  memo={memo}
                />
              </>
            ) : (
              <></>
            )}
          </>
        );
      }
    }
  };

  const renderTransportLabelSuccess = (
    transport: string,
    item: GetOrderDetailData
  ) => {
    switch (transport) {
      case "post_office":
        return (
          <>
            {" "}
            <div>
              <div style={{ marginBottom: 10 }}>
                <Typography.Text style={{ fontSize: 14, fontWeight: 400 }}>
                  ข้อมูลจัดส่งจริง
                </Typography.Text>
              </div>
              <Form form={formPostal}>
                <Form.Item label="ประเภทขนส่ง" name="selectOrganize">
                  <Input
                    size="small"
                    placeholder="ประเภทขนส่ง"
                    readOnly={true}
                    value={item?.history_postal.brand_name}
                    defaultValue={item?.history_postal.brand_name}
                  />
                </Form.Item>
                <Form.Item label="เลข Tracking" name="postalCode">
                  <Input
                    size="small"
                    placeholder="เลข Tracking"
                    readOnly={true}
                    value={item?.history_postal.postal_code}
                    defaultValue={item?.history_postal.postal_code}
                  />
                </Form.Item>
                {/* <Form.Item label="รายละเอียด" name="description">
                  <Input.TextArea placeholder="รายละเอียด" readOnly={true} />
                </Form.Item> */}
                <Form.Item label="หมายเหตุจัดส่ง" name="remark">
                  <Input.TextArea
                    placeholder="หมายเหตุจัดส่ง"
                    readOnly={true}
                    value={item?.history_postal.postal_remark}
                    defaultValue={item?.history_postal.postal_remark}
                  />
                </Form.Item>
              </Form>
            </div>
          </>
        );

      case "taxi":
        return (
          <>
            {" "}
            <div>
              <div style={{ marginBottom: 10 }}>
                <Typography.Text style={{ fontSize: 14, fontWeight: 400 }}>
                  ข้อมูลจัดส่งจริง
                </Typography.Text>
              </div>
              <Form form={formPostal}>
                <Form.Item label="ประเภทขนส่ง" name="selectOrganize">
                  <Input
                    size="small"
                    placeholder="ประเภทขนส่ง"
                    readOnly={true}
                    defaultValue={item?.history_postal.brand_name}
                  />
                </Form.Item>
                <Form.Item label="เลข Tracking" name="postalCode">
                  <Input
                    size="small"
                    placeholder="เลข Tracking"
                    readOnly={true}
                    defaultValue={item?.history_postal.postal_code}
                  />
                </Form.Item>
                {/* <Form.Item label="รายละเอียด" name="description">
                    <Input.TextArea placeholder="รายละเอียด" readOnly={true} />
                  </Form.Item> */}
                <Form.Item label="หมายเหตุจัดส่ง" name="remark">
                  <Input.TextArea
                    placeholder="หมายเหตุจัดส่ง"
                    readOnly={true}
                    value={item?.history_postal.postal_remark}
                    defaultValue={item?.history_postal.postal_remark}
                  />
                </Form.Item>
              </Form>
            </div>
          </>
        );

      case "pick_up_yourself":
        return (
          <>
            {" "}
            <div style={{ marginBottom: 10 }}>
              <Typography.Text strong style={{}}>
                ข้อมูลจัดส่งจริง
              </Typography.Text>
              {item?.history_transport.box_list.map((i, index) => {
                return (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                    }}>
                    <div style={{ flex: 3 }}>
                      <Typography.Text style={{ fontWeight: "400" }}>
                        {`จำนวนกล่อง ${i.name}`}
                      </Typography.Text>
                    </div>
                    <div style={{ flex: 4 }}>
                      <Typography.Text>{i.qty}</Typography.Text>
                    </div>
                  </div>
                );
              })}
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ flex: 3 }}>
                  <Typography.Text style={{ fontWeight: "400" }}>
                    หมายเหตุจัดส่ง
                  </Typography.Text>
                </div>
                <div style={{ flex: 4 }}>
                  <Typography.Text>
                    {item?.history_transport_location.location_remark}
                  </Typography.Text>
                </div>
              </div>
            </div>
          </>
        );
      default:
        return (
          <>
            {" "}
            <div style={{ marginBottom: 10 }}>
              <Typography.Text strong style={{}}>
                ข้อมูลจัดส่งจริง
              </Typography.Text>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ flex: 3 }}>
                  <Typography.Text style={{ fontWeight: "400" }}>
                    จังหวัด
                  </Typography.Text>
                </div>
                <div style={{ flex: 4 }}>
                  <Typography.Text>{item?.province_name}</Typography.Text>
                </div>
              </div>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ flex: 3 }}>
                  <Typography.Text style={{ fontWeight: "400" }}>
                    อำเภอ
                  </Typography.Text>
                </div>
                <div style={{ flex: 4 }}>
                  <Typography.Text>{item?.district_name}</Typography.Text>
                </div>
              </div>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ flex: 3 }}>
                  <Typography.Text style={{ fontWeight: "400" }}>
                    จุดจอด
                  </Typography.Text>
                </div>
                <div style={{ flex: 4 }}>
                  <Typography.Text>
                    {item?.history_transport.history_parking_name}
                  </Typography.Text>
                </div>
              </div>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ flex: 3 }}>
                  <Typography.Text style={{ fontWeight: "400" }}>
                    ขนส่ง
                  </Typography.Text>
                </div>
                <div style={{ flex: 4 }}>
                  <Typography.Text>
                    {item?.history_transport.transport_name}
                  </Typography.Text>
                </div>
              </div>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ flex: 3 }}>
                  <Typography.Text style={{ fontWeight: "400" }}>
                    เวลาถึง
                  </Typography.Text>
                </div>
                <div style={{ flex: 4 }}>
                  <Typography.Text>
                    {item?.history_transport.end_time}
                  </Typography.Text>
                </div>
              </div>
              {item?.history_transport.box_list.map((i, index) => {
                return (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                    }}>
                    <div style={{ flex: 3 }}>
                      <Typography.Text style={{ fontWeight: "400" }}>
                        {`จำนวนกล่อง ${i.name}`}
                      </Typography.Text>
                    </div>
                    <div style={{ flex: 4 }}>
                      <Typography.Text>{i.qty}</Typography.Text>
                    </div>
                  </div>
                );
              })}
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ flex: 3 }}>
                  <Typography.Text style={{ fontWeight: "400" }}>
                    หมายเหตุจัดส่ง
                  </Typography.Text>
                </div>
                <div style={{ flex: 4 }}>
                  <Typography.Text>
                    {item?.history_transport.remark_box}
                  </Typography.Text>
                </div>
              </div>
            </div>
          </>
        );
    }
  };

  return (
    <>
      {item && (
        <div>
          <Modal
            open={open}
            // maskClosable={false}
            onCancel={() => {
              onClose();
              clearForm();
            }}
            width={1280}
            footer={null}
            style={{ top: 20 }}>
            <div style={{ borderBottom: "1px solid #f0f0f0" }}>
              <Row style={{ marginBottom: 10 }}>
                <Col style={{}} span={12}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}>
                    <Typography.Text
                      style={{ whiteSpace: "nowrap", marginRight: "5px" }}>{`${item.items[0]?.order_code || ""
                        }`}</Typography.Text>
                    <div
                      style={{
                        borderRight: "1px solid #f0f0f0",
                      }}></div>
                    <ModalPrintPurchaseOrder item={item} />
                    <FormWrapper style={{ marginRight: "5px" }}>
                      {(statusPage === "prepare_ship" ||
                        statusPage === "new_order") &&
                        item.due_date && (
                          <>
                            <Button onClick={OpenDue}>
                              <FormOutlined />
                              วันที่ต้องส่งสินค้า {formatDate(dueDate)}
                            </Button>
                          </>
                        )}
                      {statusPage !== "prepare_ship" &&
                        statusPage !== "new_order" &&
                        item.due_date && (
                          <>
                            <Typography.Text
                              style={{
                                borderRadius: "5px",
                                padding: "2px",
                                backgroundColor: "red",
                                color: "yellow",
                                whiteSpace: "nowrap",
                              }}>
                              วันที่ต้องส่งสินค้า {formatDate(dueDate)}
                            </Typography.Text>
                          </>
                        )}
                    </FormWrapper>
                    {item?.tax_invoice?.taxinvoice_id && (
                      <FormWrapper style={{ marginRight: "5px" }}>
                        <Button
                          onClick={() => {
                            setOpenTax(true);
                          }}>
                          ข้อมูลใบกำกับภาษี
                        </Button>
                      </FormWrapper>
                    )}
                  </div>
                </Col>
                <Col
                  span={12}
                  style={{ display: "flex", justifyContent: "flex-end" }}>
                  {statusPage !== "new_order" &&
                    statusPage !== "prepare_ship" && (
                      <Button
                        type="default"
                        onClick={() => {
                          window.open(`/print-deliverynote/${item?.order_id}`);
                        }}
                        style={{ marginRight: "20px" }}>
                        พิมพ์ใบส่งของ
                      </Button>
                    )}
                </Col>
              </Row>
            </div>

            <Row>
              <Col span={8} xs={24} md={24} lg={24} xl={8} style={{}}>
                <HeaderTab>
                  <Typography.Text
                    style={{
                      fontWeight: "normal",
                      paddingBottom: 5,
                      paddingTop: 5,
                    }}>
                    รายการสินค้า
                  </Typography.Text>
                </HeaderTab>
                <div style={{ borderRight: "1px solid #f0f0f0" }}>
                  <Space
                    direction="vertical"
                    size="middle"
                    style={{
                      display: "flex",
                      height: "50vh",
                      overflowY: "scroll",
                      paddingRight: 10,
                      paddingTop: 10,
                    }}>
                    {item?.items.map((i, index) => (
                      <div key={i.price_id}>
                        <Row>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              width: "100%",
                            }}>
                            <div style={{ marginRight: 10 }}>
                              <Checkbox />
                            </div>
                            <div style={{ flex: 1.5 }}>
                              <img
                                src={i.image_url}
                                alt={i.product_name}
                                style={{
                                  width: 80,
                                  height: 80,
                                  marginRight: 10,
                                }}
                              />
                            </div>
                            <div style={{ flex: 3, marginLeft: 10 }}>
                              <Typography.Paragraph style={{ marginBottom: 0 }}>
                                {i.product_name}
                              </Typography.Paragraph>
                              <Typography.Paragraph
                                style={{ fontSize: "12px" }}>
                                {i.sku_description}
                              </Typography.Paragraph>
                              {isCanceledItemStatus(i.item_status) && (
                                <Tag
                                  color="error"
                                  style={{ marginInlineEnd: 0 }}>
                                  ยกเลิก
                                </Tag>
                              )}
                            </div>
                            <div
                              style={{
                                flex: 1,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "end",
                              }}>
                              {item.order_is_vip ? (
                                <>
                                  <Typography.Paragraph
                                    style={{ marginBottom: 0 }}>
                                    {numberFormat(i.wholesale_price)} บาท
                                  </Typography.Paragraph>
                                  <Typography.Text
                                    style={{
                                      fontSize: "12px",
                                      whiteSpace: "nowrap",
                                    }}
                                    type="warning">
                                    ราคาสิทธิพิเศษ {numberFormat(i.vip_price)}{" "}
                                    บาท
                                  </Typography.Text>
                                </>
                              ) : (
                                <Typography.Paragraph
                                  style={{ marginBottom: 0 }}>
                                  {item.ref_source === "retail"
                                    ? numberFormat(i.wholesale_price)
                                    : numberFormat(i.sku_price)}{" "}
                                  บาท
                                </Typography.Paragraph>
                              )}

                              <Typography.Paragraph style={{ marginBottom: 0 }}>
                                จำนวน {i.sku_cnt}
                              </Typography.Paragraph>
                              {/*
                              {statusPage === "prepare_ship" && (
                                <Popconfirm
                                  title="ยืนยันจัดส่งรายการนี้?"
                                  onConfirm={() => {
                                    confirmItemShipped(
                                      { retail_order_item_ids: [i.order_item_id] },
                                      {
                                        onSuccess: (res) => {
                                          if (res.status === "success") {
                                            message.success("ยืนยันจัดส่งสินค้าสำเร็จ");
                                            refetchData();
                                            refetchPrepare && refetchPrepare();
                                            refectShipped && refectShipped();
                                          }
                                        },
                                      }
                                    );
                                  }}
                                >
                                  <Button size="small" type="link" style={{ padding: 0 }}>
                                    ยืนยันจัดส่ง
                                  </Button>
                                </Popconfirm>
                              )}*/}
                            </div>
                          </div>
                          {i.contact_comment_item && (
                            <Typography.Paragraph
                              style={{
                                fontSize: "12px",
                                marginTop: 5,
                                marginLeft: 25,
                                whiteSpace: "pre-line",
                              }}>
                              <span style={{ fontWeight: 500 }}>
                                โน๊ตผู้ประกอบการ:
                              </span>{" "}
                              &nbsp;
                              {i.contact_comment_item}
                            </Typography.Paragraph>
                          )}
                        </Row>
                      </div>
                    ))}
                  </Space>
                  <div
                    style={{
                      display: "flex",
                      marginRight: 10,
                      marginTop: 10,
                    }}>
                    <div style={{ flex: 1 }}>
                      <Typography.Text style={{ fontWeight: "400" }}>
                        ช่องทางการสั่งซื้อ
                      </Typography.Text>
                    </div>
                    <div
                      style={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "end",
                      }}>
                      <Typography.Text style={{ fontWeight: "600" }}>
                        {getContactMethodName(item?.datasource, "en")}
                      </Typography.Text>
                    </div>
                  </div>
                  <div
                    style={{ borderTop: "1px solid #f0f0f0", marginRight: 10 }}>
                    <div
                      style={{
                        display: "flex",
                        marginRight: 10,
                        marginTop: 10,
                      }}>
                      <div
                        style={{
                          flex: 1,
                          display: "flex",
                          alignItems: "center",
                        }}>
                        <Typography.Text style={{}}>
                          ยอดรวมสินค้า
                        </Typography.Text>
                      </div>
                      <div
                        style={{
                          flex: 1,
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "end",
                        }}>
                        {item && (
                          <Typography.Text>
                            {numberFormat(totalOrderPrice)} บาท
                          </Typography.Text>
                        )}
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        marginRight: 10,
                        marginTop: 10,
                      }}>
                      <div
                        style={{
                          flex: 1,
                          display: "flex",
                          alignItems: "center",
                        }}>
                        <Typography.Text style={{}}>ค่าจัดส่ง</Typography.Text>
                      </div>
                      <div
                        style={{
                          flex: 1,
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "end",
                        }}>
                        <Typography.Text>
                          {numberFormat(totalTransportAmount)} บาท
                        </Typography.Text>
                      </div>
                    </div>
                    {item.order_is_vip && item.extra_discount_amount &&
                      item.extra_discount_amount > 0 ? (
                      // <div
                      //   style={{
                      //     display: "flex",
                      //     marginRight: 10,
                      //     marginTop: 10,
                      //   }}>
                      //   <div
                      //     style={{
                      //       flex: 1,
                      //       display: "flex",
                      //       alignItems: "center",
                      //     }}>
                      //     <Typography.Text style={{}}>
                      //       ส่วนลดสิทธิพิเศษ
                      //     </Typography.Text>
                      //   </div>
                      //   <div
                      //     style={{
                      //       flex: 1,
                      //       display: "flex",
                      //       flexDirection: "column",
                      //       alignItems: "end",
                      //     }}>
                      //     <div
                      //       style={{
                      //         flex: 1,
                      //         display: "flex",
                      //         alignItems: "center",
                      //       }}>
                      //       <Typography.Text type="warning">
                      //         {numberFormat(item.extra_discount_amount)} บาท
                      //       </Typography.Text>
                      //     </div>
                      //   </div>
                      // </div>
                      <></>
                    ) : null}

               
                  </div>
                  <div
                    style={{ borderTop: "1px solid #f0f0f0", marginRight: 10 }}>
                    <div
                      style={{
                        display: "flex",
                        marginRight: 10,
                        marginTop: 10,
                      }}>
                      <div
                        style={{
                          flex: 1,
                          display: "flex",
                          alignItems: "center",
                        }}>
                        <Typography.Text style={{ fontWeight: "500" }}>
                          ยอดรวมทั้งหมด
                        </Typography.Text>
                      </div>
                      <div
                        style={{
                          flex: 1,
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "end",
                        }}>
                        {item && (
                          <Typography.Text style={{ fontWeight: "500" }}>
                            {numberFormat(totalAmountPrice)} บาท
                          </Typography.Text>
                        )}
                      </div>
                    </div>
                         {item.discount_amount && item.discount_amount > 0 ? (
                      <div
                        style={{
                          display: "flex",
                          marginRight: 10,
                          marginTop: 10,
                        }}>
                        <div
                          style={{
                            flex: 1,
                            display: "flex",
                            alignItems: "center",
                          }}>
                          <Typography.Text style={{}}>
                            ส่วนลดจากโรงงงาน
                          </Typography.Text>
                        </div>
                        <div
                          style={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "end",
                          }}>
                          <div
                            style={{
                              flex: 1,
                              display: "flex",
                              alignItems: "center",
                            }}>
                            <Typography.Text>
                              - {numberFormat(item?.discount_amount)} บาท
                            </Typography.Text>
                          </div>
                        </div>
                      </div>
                    ) : null}
                    <div
                      style={{
                        display: "flex",
                        marginRight: 10,
                        marginTop: 10,
                      }}>
                      <div
                        style={{
                          flex: 1,
                          display: "flex",
                          alignItems: "center",
                        }}>
                        <Typography.Text>ยอดชำระเงินรวม</Typography.Text>
                      </div>
                      <div
                        style={{
                          flex: 1,
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "end",
                        }}>
                        {item && (
                          <Typography.Text>
                            {numberFormat(displayPaymentAmount )} บาท
                          </Typography.Text>
                        )}
                      </div>
                    </div>
                    {(item.datasource === "app_agent" || item.datasource === "ecommerce_web") && (
                      <div
                        style={{
                          display: "flex",
                          marginRight: 10,
                          marginTop: 10,
                        }}>
                        <div
                          style={{
                            flex: 1,
                            display: "flex",
                            alignItems: "center",
                          }}>
                          <Typography.Text>ชำระด้วย Point รวม</Typography.Text>
                        </div>
                        <div
                          style={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "end",
                          }}>
                          {item && (
                            <Typography.Text>
                              {numberFormat(item.pay_point)} บาท
                            </Typography.Text>
                          )}
                        </div>
                      </div>
                    )}
                    <div
                      style={{
                        display: "flex",
                        marginRight: 10,
                        marginTop: 10,
                      }}>
                      <div
                        style={{
                          flex: 1,
                          display: "flex",
                          alignItems: "center",
                        }}>
                        <Typography.Text style={{ fontWeight: 500 }}>
                          ยอดเงินคงเหลือที่ต้องชำระ
                        </Typography.Text>
                      </div>
                      <div
                        style={{
                          flex: 1,
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "end",
                        }}>
                        {item && Number(remainingAmount) > 0 && (
                          <Typography.Text
                            style={{ fontWeight: 500, color: "red" }}>
                            {/* COD ใช้ remainingAmount เสมอเหมือน manual_transfer (คำนวณจาก paid_amt
                                แล้ว ไม่ใช่ bank_payment) — payment type อื่นที่ยังไม่ผูก paid_amt
                                ค่อย fallback ไป totalPrice - pay_point ตามเดิม */}
                            {item.order_payment_type === "manual_transfer" ||
                            item.order_payment_type === "COD"
                              ? numberFormat(Number(remainingAmount))
                              : effectivePaymentStatus === "partial_payment"
                                ? numberFormat(Number(remainingAmount))
                                : numberFormat(
                                  Number(totalPrice - item.pay_point)
                                )}{" "}
                            บาท
                          </Typography.Text>
                        )}
                        {/* 30/9/2026 — บรรทัด "ชำระเงินเกินมา n บาท" (แดง) เหลือเฉพาะออเดอร์เงินโอน
                            (manual_transfer) ที่โรงงานต้องคืนเงินส่วนเกินให้ลูกค้าเอง · ประเภทอื่นวาดเหมือน
                            จ่ายครบและไม่บอกส่วนต่าง เพราะเงินส่วนเกินไม่ใช่งานของโรงงาน แต่ประโยคสีแดง
                            อ่านว่ามีอะไรต้องจัดการ · เงื่อนไขยังแยกไว้ไม่รวมกับ === 0 ข้างล่าง เพราะบล็อกนั้น
                            พ่วง payment_status === "confirm" อยู่ ถ้ารวมดื้อ ๆ ออเดอร์จ่ายเกินที่สถานะยังเป็น
                            pending จะไม่วาดอะไรเลย */}
                        {item && Number(remainingAmount) < 0 &&
                          (item.order_payment_type === "manual_transfer" ? (
                            <Typography.Text style={{ fontWeight: 500, color: "red" }}>
                              ชำระเงินเกินมา {numberFormat(-Number(remainingAmount))} บาท
                            </Typography.Text>
                          ) : (
                            <Typography.Text style={{ fontWeight: 500, color: "green" }}>
                              ชำระเงินครบถ้วนแล้ว
                            </Typography.Text>
                          ))}
                        {item &&
                          Number(remainingAmount) === 0 &&
                          effectivePaymentStatus === "confirm" && (
                            <Typography.Text
                              style={{ fontWeight: 500, color: "green" }}>
                              ชำระเงินครบถ้วนแล้ว
                            </Typography.Text>
                          )}

                        {item &&
                          Number(remainingAmount) === 0 &&
                          effectivePaymentStatus === "pending" && (
                            <Typography.Text
                              style={{ fontWeight: 500, color: "red" }}>
                              {numberFormat(totalPrice - item.pay_point)} บาท
                            </Typography.Text>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col span={8} xs={24} md={24} lg={24} xl={8}>
                <HeaderTab>
                  <Typography.Text
                    style={{
                      fontWeight: "normal",
                      paddingBottom: 5,
                      paddingTop: 5,
                    }}>
                    การชำระเงิน
                  </Typography.Text>
                </HeaderTab>
                <div
                  style={{
                    borderRight: "1px solid #f0f0f0",
                    height: "60vh",
                    overflowY: "scroll",
                  }}>
                  <Tabs
                    defaultActiveKey={"0"}
                    style={{ height: "100%" }}
                    items={[
                      {
                        label: `การชำระเงิน (${item.bank_payment.length})`,
                        key: "1",
                        children: (
                          <>
                            {statusPage === "new_order" &&
                              orderManualConfirm.includes(
                                item.order_payment_type
                              ) && (
                                <>
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "flex-end",
                                      padding: 10,
                                    }}>
                                    <Typography.Text
                                      style={{
                                        textAlign: "center",
                                        color: "red",
                                      }}>
                                      ลูกค้าได้แจ้งชำระเงินโดยการโอนเข้าบัญชีต่อไปนี้ผ่านทางบิลออนไลน์
                                      กรุณาตรวจสอบข้อมูลกับธนาคาร
                                      หากถูกต้องแล้วจึงกดปุ่ม <br />{" "}
                                      ยืนยันคำสั่งซื้อ
                                    </Typography.Text>
                                  </div>
                                  <div
                                    style={{
                                      marginLeft: 10,
                                      marginRight: 10,
                                      borderBottom: "1px solid #f0f0f0",
                                    }}
                                  />
                                </>
                              )}
                            <div style={{ padding: 10 }}>
                              {(statusPage === "new_order" ||
                                statusPage === "paid_credit" ||
                                effectivePaymentStatus === "partial_payment" ||
                                effectivePaymentStatus === "pending") &&
                                statusPage !== "completed" ? (
                                orderManualConfirm.includes(
                                  item.order_payment_type
                                ) ? (
                                  <>
                                    {(effectivePaymentStatus ===
                                      "partial_payment" ||
                                      effectivePaymentStatus === "pending") &&
                                      Number(remainingAmount || 0) > 0 && (
                                        <Alert
                                          message={`คุณมียอดค้างชำระอีก ${numberFormat(
                                            Number(remainingAmount || 0) 
                                          )} บาท`}
                                          // description="กรุณาตรวจสอบหลักฐานการชำระเงินของลูกค้า และ เลือกข้อมูลบัญชีธนาคารที่ถูกต้องอย่างละเอียด ก่อนกดปุ่ม 'ยืนยัน'"
                                          type="error"
                                          showIcon
                                        />
                                      )}

                                    <Form form={form} onFinish={onFinish}>
                                      {dataPaymentItems?.map((data, index) => {
                                        return (
                                          <ConfirmPaymentDetail
                                            key={index}
                                            index={data?.id ?? index.toString()}
                                            order_id={item.order_id}
                                            formValues={formValues}
                                            form={form}
                                            item={data}
                                            onClose={onClose}
                                            childrenBank={childrenBank}
                                            refetchData={refetchData}
                                            refetchPrepare={refetchPrepare}
                                            onRemove={() =>
                                              handleRemovePaymentItem(index)
                                            }
                                            inputRef={(el) =>
                                            (paymentAmountRefs.current[
                                              index
                                            ] = el)
                                            }
                                          />
                                        );
                                      })}
                                    </Form>
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        padding: 10,
                                      }}>
                                      <Button
                                        ref={addPaymentButtonRef}
                                        onClick={() => {
                                          const newPaymentItem: GetOrderDetailBankpayment =
                                          {
                                            id: `${dataPaymentItems.length}`,
                                            bank_id: "",
                                            pay_amount: 0,
                                          };
                                          setDataPaymentItems([
                                            ...dataPaymentItems,
                                            newPaymentItem,
                                          ]);
                                        }}>
                                        เพิ่มการชำระเงินใหม่
                                      </Button>
                                    </div>
                                  </>
                                ) : item.order_payment_type === "COD" &&
                                  dataPaymentItems.length === 0 ? (
                                  // COD ยังไม่มี OrderPaymentDetail (bank_payment) จนกว่าจะเก็บเงินสำเร็จ
                                  // (manualTranfer สร้างแค่ OrderPaymentHead) — แสดงช่องทาง/จำนวนเงินเอง
                                  // จากยอดรวมออเดอร์ ไม่ต้องรอ bank_payment
                                  // ⚠️ ต้องครอบด้วย Form เดียวกันเสมอ — ปุ่มยืนยันเรียก form.submit() ถ้าไม่มี
                                  // Form ตัวนี้ mount อยู่ onFinish จะไม่ถูกเรียกเลย (กดยืนยันแล้วเงียบ)
                                  <Form form={form} onFinish={onFinish}>
                                    <ConfirmPaymentPromptpay
                                      paymentType={item.order_payment_type}
                                      item={
                                        {
                                          id: "cod-pending",
                                          bank_id: "",
                                          // หลัง webhook เก็บเงินแล้ว แสดงยอดที่เก็บได้จริงทันที
                                          // (เดิมใช้ resultPrice ตลอด ทำให้ต้องกด refresh ถึงจะถูก)
                                          pay_amount:Number(effectivePaidAmt ?? 0)
                                        } as GetOrderDetailBankpayment
                                      }
                                      payment_point={item.pay_point}
                                    />
                                  </Form>
                                ) : (
                                  <>
                                    {/* {(item.payment_status ===
                                      "partial_payment" ||
                                      item.payment_status === "pending") &&
                                      Number(remainingAmount || 0) > 0 && (
                                        <Alert
                                          message={`ยอดชำระเพิ่มด้วยเงินสดอีก ${numberFormat(
                                            Number(remainingAmount || 0)
                                          )} บาท กรุณาตรวจสอบ`}
                                          // description="กรุณาตรวจสอบหลักฐานการชำระเงินของลูกค้า และ เลือกข้อมูลบัญชีธนาคารที่ถูกต้องอย่างละเอียด ก่อนกดปุ่ม 'ยืนยัน'"
                                          type="error"
                                          showIcon
                                        />
                                      )} */}

                                    <Form form={form} onFinish={onFinish}>
                                      {dataPaymentItems?.map((data, index) => {
                                        return (
                                          <>
                                            {data.bank_id !== null ? (
                                              <ConfirmPaymentDetail
                                                key={index}
                                                index={
                                                  data?.id ?? index.toString()
                                                }
                                                order_id={item.order_id}
                                                formValues={formValues}
                                                form={form}
                                                item={data}
                                                onClose={onClose}
                                                childrenBank={childrenBank}
                                                refetchData={refetchData}
                                                refetchPrepare={refetchPrepare}
                                                onRemove={() =>
                                                  handleRemovePaymentItem(index)
                                                }
                                              />
                                            ) : (
                                              <>
                                                <ConfirmPaymentPromptpay
                                                  paymentType={
                                                    item.order_payment_type
                                                  }
                                                  item={data}
                                                  payment_point={item.pay_point}
                                                  discountDeduct={
                                                    index === 0
                                                      ? shipShopDiscount
                                                      : 0
                                                  }
                                                />
                                                <div
                                                  style={{
                                                    borderBottom:
                                                      "1px solid #f0f0f0",
                                                    marginTop: 10,
                                                  }}
                                                />
                                              </>
                                            )}
                                          </>
                                        );
                                      })}
                                    </Form>
                                    {/* <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        padding: 10,
                                      }}
                                    >
                                      <Button
                                        ref={addPaymentButtonRef}
                                        onClick={() => {
                                          const newPaymentItem: GetOrderDetailBankpayment =
                                            {
                                              id: `${dataPaymentItems.length}`,
                                              bank_id: "",
                                              pay_amount: 0,
                                            };
                                          setDataPaymentItems([
                                            ...dataPaymentItems,
                                            newPaymentItem,
                                          ]);
                                        }}
                                      >
                                        เพิ่มการชำระเงินใหม่
                                      </Button>
                                    </div> */}
                                  </>
                                )
                              ) : (
                                <>
                                  {item.bank_payment.length > 0 ? (
                                    <>
                                      {item.bank_payment.map((data, index) => {
                                        return (
                                          <ConfirmPaymentPromptpay
                                            paymentType={
                                              item.order_payment_type
                                            }
                                            item={data}
                                            payment_point={item.pay_point}
                                            discountDeduct={
                                              index === 0 ? shipShopDiscount : 0
                                            }
                                          />
                                        );
                                      })}
                                    </>
                                  ) : item.order_payment_type === "COD" ? (
                                    // COD ไม่มี bank_payment เลย (ไม่ใช่การโอนเงิน) — แถบนี้เป็น
                                    // read-only (เช่น "เสร็จสิ้น") จึงไม่เข้า branch แก้ไขด้านบนที่มี
                                    // fallback ของ COD อยู่แล้ว (เงื่อนไข statusPage !== "completed")
                                    // แสดงยอดที่เก็บ COD ได้จริงสะสม (paid_amt) แทน ไม่ใช่ resultPrice
                                    // เต็มจำนวนแบบ branch "ยังไม่เก็บเงิน" ด้านบน เพราะออเดอร์เก็บเงิน
                                    // ไปแล้วจริง (ไม่ใช่ pending)
                                    <ConfirmPaymentPromptpay
                                      paymentType={item.order_payment_type}
                                      item={
                                        {
                                          id: "cod-collected",
                                          bank_id: "",
                                          pay_amount: effectivePaidAmt ?? 0,
                                        } as GetOrderDetailBankpayment
                                      }
                                      payment_point={item.pay_point}
                                    />
                                  ) : (
                                    <Alert
                                      message="ไม่พบข้อมูลการชำระเงิน"
                                      type="warning"
                                    />
                                  )}
                                </>
                              )}
                            </div>
                            <div style={{ padding: "0 10px 10px" }}>
                              <CodCreditInfoSingle
                                orderId={item.order_id}
                                enabled={statusPage === "new_order" && item.order_payment_type === "COD"}
                              />
                            </div>
                          </>
                        ),
                      },
                      {
                        label: `การคืนเงิน (${refundList?.data.length || 0})`,
                        key: "2",
                        children: (
                          <>
                            <PaymentRefundDetailList
                              refundList={refundList}
                              setRefundList={setRefundList}
                              item={item}
                            />
                          </>
                        ),
                      },
                    ]}
                    key="key"></Tabs>
                </div>
                <div style={{ borderTop: "1px solid #f0f0f0", padding: "5px" }}>
                  <div
                    style={{
                      display: "flex",
                      marginRight: 10,
                      marginTop: 10,
                    }}>
                    <div style={{ flex: 1 }}>
                      <Typography.Text style={{ fontWeight: "500" }}>
                        บันทึกช่วยจำ
                      </Typography.Text>
                      <Input.TextArea
                        rows={3}
                        value={memo}
                        onChange={(e) => {
                          setMemo(e.target.value);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </Col>
              <Col span={8} xs={24} md={24} lg={24} xl={8}>
                <HeaderTab>
                  <Typography.Text
                    style={{
                      fontWeight: "normal",
                      paddingBottom: 5,
                      paddingTop: 5,
                    }}>
                    การจัดส่ง
                  </Typography.Text>
                </HeaderTab>
                <div
                  style={{
                    // borderRight: "1px solid #f0f0f0",
                    height: "71.5vh",
                    overflowY: "scroll",
                  }}>
                  <div style={{ padding: 30 }}>
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <div style={{ flex: 2 }}>
                        <Typography.Text style={{ fontWeight: "400" }}>
                          ประเภทการจัดส่ง
                        </Typography.Text>
                      </div>
                      <div style={{ flex: 4 }}>
                        <Typography.Text>{transportText}</Typography.Text>
                      </div>
                    </div>
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <div style={{ flex: 2 }}>
                        <Typography.Text style={{ fontWeight: "400" }}>
                          ชื่อผู้รับ
                        </Typography.Text>
                      </div>
                      <div style={{ flex: 4 }}>
                        <Typography.Text>
                          {shipShopRecipientDisplay ? item.ref_name : item.address_name}{" "}
                          {item.order_is_vip && (
                            <Tag color="red">
                              <CrownOutlined /> VIP
                            </Tag>
                          )}
                        </Typography.Text>
                      </div>
                    </div>
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <div style={{ flex: 2 }}>
                        <Typography.Text style={{ fontWeight: "400" }}>
                          ประเภท
                        </Typography.Text>
                      </div>
                      <div style={{ flex: 4 }}>
                        <Typography.Text>
                          {/* {item.ref_source} */}
                          ลูกค้า
                          </Typography.Text>
                      </div>
                    </div>
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <div style={{ flex: 2 }}>
                        <Typography.Text style={{ fontWeight: "400" }}>
                          เบอร์โทรศัพท์
                        </Typography.Text>
                      </div>
                      <div style={{ flex: 4 }}>
                        <Typography.Text>
                          {shipShopRecipientDisplay
                            ? (item.ref_telephone ?? "")
                            : item.address_telephone}
                        </Typography.Text>
                      </div>
                    </div>
                    {!shipShopRecipientDisplay && (
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <div style={{ flex: 2 }}>
                        <Typography.Text style={{ fontWeight: "400" }}>
                          ที่อยู่
                        </Typography.Text>
                      </div>
                      <div style={{ flex: 4 }}>
                        <Typography.Text>{item.address_text}</Typography.Text>
                      </div>
                    </div>
                    )}
                    {/* "จุดจอด"/"หมายเหตุจุดจอด" มีความหมายเฉพาะ transport_type ที่ใช้จุดจอดจริง
                        (ไม่ใช่ post_office/pick_up_yourself/taxi — ดู renderTransportLabel ด้านบน:
                        3 ประเภทนี้ใช้ PostalSelect/TransportLocal ที่ไม่มี concept จุดจอดเลย)
                        หมายเหตุ: ยังไม่กรอง parking ที่เป็นค่า default ของจังหวัด (master_parking.
                        is_default) ที่ติดมาจากที่อยู่ที่บันทึกไว้ — ต้องแก้ backend เพิ่มถ้าจะกรองส่วนนี้ */}
                    {!shipShopRecipientDisplay &&
                      item.transport_type !== "post_office" &&
                      item.transport_type !== "pick_up_yourself" &&
                      item.transport_type !== "taxi" &&
                      item.transport_type != null && (
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <div style={{ flex: 2 }}>
                        <Typography.Text style={{ fontWeight: "400" }}>
                          จุดจอด
                        </Typography.Text>
                      </div>
                      <div style={{ flex: 4 }}>
                        <Typography.Text>{item.parking_name}</Typography.Text>
                      </div>
                    </div>
                    )}
                    {!shipShopRecipientDisplay &&
                      item.transport_type !== "post_office" &&
                      item.transport_type !== "pick_up_yourself" &&
                      item.transport_type !== "taxi" &&
                      item.transport_type != null && (
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <div style={{ flex: 2 }}>
                        <Typography.Text style={{ fontWeight: "400" }}>
                          หมายเหตุจุดจอด
                        </Typography.Text>
                      </div>
                      <div style={{ flex: 4 }}>
                        <Typography.Text>
                          {item?.address_remark}
                        </Typography.Text>
                      </div>
                    </div>
                    )}
                  </div>
                  <div style={{ borderTop: "1px solid #f0f0f0" }}></div>
                  { !hideCompletedShipShopShippingUi &&
                    !hidePrepareShipShopTrackingPanel && (
                      <div style={{ padding: 10 }}>
                        {/* {item.transport_type === "post_office" ? (
                        statusPage === "prepare_ship" ? (
                          <PostalSelect
                            formPostal={formPostal}
                            item={item}
                            refetchData={refetchData}
                            refectShipped={refectShipped}
                            onClose={onClose}
                            memo={memo}
                          />
                        ) : (
                          <PostalLabel
                            formPostal={formPostal}
                            item={item}
                            refetchData={refetchData}
                            refectShipped={refectShipped}
                            onClose={onClose}
                          />
                        )
                      } : statusPage === "prepare_ship" ? (
                        <TransportSeleect
                          formTransport={formTransport}
                          item={item}
                          refetchData={refetchData}
                          refectShipped={refectShipped}
                          statusPage={statusPage}
                          onClose={onClose}
                          memo={memo}
                        />
                      ) : (
                        <>
                          {statusPage === "shipped" ? (
                            <UpdateTransportSeleect
                              formTransport={formTransport}
                              item={item}
                              refetchData={refetchData}
                              refectShipped={refectShipped}
                              statusPage={statusPage}
                              onClose={onClose}
                              memo={memo}
                            />
                          ) : (
                            <></>
                          )}
                        </>
                      )} */}
                      {/*ต้องแสดงเฉพาะลุงอเนก*/}
                      
                        {use_platform_transport || isAppAgent ? (
                        <div style={{ marginTop: 5 }}>
                          {/* แจ้งรอกรอกเลขพัสดุ (ส่งเอง) ไว้บนสุด ให้เห็นก่อนรายการเลขพัสดุ */}
                          <SelfTrackingPendingCard
                            items={selfPendingDetailItems}
                            hasPlatformItems={!selfTrackingState?.selfOnly}
                            onOpen={() => setShowSelfTracking(true)}
                          />
                          <TrackingNumberPanel
                            orderId={item.order_id}
                            isOpen={open}
                            onTrackingStatusChange={(isComplete, isPrinted) => {
                              setIsAllTrackingComplete(isComplete);
                              setIsAllTrackingPrinted(isPrinted);
                            }}
                            // แถบเครดิตรอชำระ/เสร็จสิ้น/ยกเลิก ไม่ต้องมีสถานะพิมพ์/ปุ่มพิมพ์แล้ว เหลือแค่ปุ่ม copy
                            hidePrintControls={statusPage === "paid_credit" || statusPage === "completed" || statusPage === "cancel"}
                            hideEmptyState={selfPendingDetailItems.length > 0}
                            bbCodeOnly={statusPage === "prepare_ship" || statusPage === "shipped"}
                            // ระหว่างจัดส่ง: แก้เลขพัสดุ/บริษัทขนส่งของส่งเองที่กรอกไว้แล้วได้
                            allowEditSelfTracking={statusPage === "shipped"}
                          />
                       </div>
                        ) : (
                          <div style={{ marginTop: 5 }}>
                            {renderTransportLabel(item.transport_type, item)}
                          </div>
                        )}
                      </div>
                    )}

                  {statusPage !== "cancel" &&
                    item.transport_type !== "post_office" &&
                    item.transport_type !== null &&
                    statusPage !== "prepare_ship" &&
                    statusPage !== "shipped" &&
                    statusPage !== "new_order" &&
                    !hideCompletedShipShopShippingUi && (
                      <div style={{ padding: 10 }}>
                        {/* <TransportLabel
                          formTransport={formTransport}
                          item={item}
                          refetchData={refetchData}
                          refectShipped={refectShipped}
                          statusPage={statusPage ?? ""}
                          onClose={onClose}
                        /> */}
                        {renderTransportLabelSuccess(item.transport_type, item)}
                      </div>
                    )}

                  {statusPage === "cancel" && item.reason_cancel && (
                    <CancelDetailLabel item={item} />
                  )}
                </div>
              </Col>
            </Row>
            <div style={{ borderTop: "1px solid #f0f0f0" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: "row",
                  alignItems: "end",
                  marginTop: 10,
                }}>
                <div>
                  {(statusPage === "new_order" ||
                    statusPage === "prepare_ship") && (
                      <div>
                        <Button
                          type="default"
                          danger
                          onClick={() => {
                            OpenCancel();
                          }}
                          // disabled={
                          //   !isAdmin &&
                          //   item.order_payment_type != "manual_transfer"
                          // }
                          style={{ marginRight: "5px" }}>
                          ยกเลิกคำสั่งซื้อ
                        </Button>
                        <Button
                          type="default"
                          onClick={() => {
                            if (showEditModal) {
                              onClose();
                              showEditModal(
                                item?.order_id ?? "",
                                item?.ref_id ?? ""
                              );
                            }
                          }}
                          style={{ marginRight: "5px" }}
                          disabled={
                            item.order_payment_type != "manual_transfer"
                          }>
                          แก้ไขคำสั่งซื้อ
                        </Button>
                      </div>
                    )}
                </div>
                <div>
                  <>
                    {/* {(statusPage === "cancel" || statusPage === "complete") && (
                      <>
                        <Button
                          type="primary"
                          onClick={() => {
                            // OpenCancel();
                          }}
                          style={{ marginRight: "5px" }}
                        >
                          บันทึก
                        </Button>
                      </>
                    )}   */}
                    {/* {(statusPage === "shipped" || statusPage === "cancel" || statusPage === "completed") && ( */}
                    <>
                      {statusPage === "cancel" && isAdmin && (
                        <Popconfirm
                          title="ยืนยันการคืนค่า"
                          description="คุณต้องการยืนยันการคืนค่าคำสั่งซื้อนี้หรือไม่? หากถูกต้องแล้วจึงกดปุ่ม ยืนยัน"
                          okText="ยืนยัน"
                          cancelText="ยกเลิก"
                          onConfirm={() => {
                            handleRevertManualOrder();
                          }}
                        >
                          <Button
                            type="default"
                            style={{
                              marginRight: "8px",
                              backgroundColor: "#22c55e",
                              color: "#fff",
                              border: "none",
                              boxShadow: "0 1px 3px rgba(34, 197, 94, 0.35)",
                            }}
                          >
                            <UndoOutlined /> คืนค่าคำสั่งซื้อ
                          </Button>
                        </Popconfirm>
                      )}
                      <Button
                        type="default"
                        onClick={() => {
                          // OpenCancel();
                          let updateOrderInput: FactoryUpdateOrderInput = {
                            order_id: item?.order_id ?? "",
                            // order_list: [],
                            memo: memo,
                          };
                          updateOrder(updateOrderInput, {
                            onSuccess: (res) => {
                              if (res.status === "success") {
                                message.success("แก้ไขคำสั่งซื้อสำเร็จ");
                                refetchData();
                                onClose();
                              } else {
                                message.error(
                                  `แก้ไขคำสั่งซื้อไม่สำเร็จ: ${res.error_message}`
                                );
                              }
                            },
                            onError: (error) => {
                              message.error(
                                `แก้ไขคำสั่งซื้อไม่สำเร็จ: ${error.message}`
                              );
                            },
                          });
                        }}
                        style={{ marginRight: "5px" }}>
                        บันทึกข้อมูลช่วยจำ
                      </Button>
                    </>
                    {/* )} */}

                    {(statusPage === "new_order" ||
                      statusPage === "paid_credit" ||
                      effectivePaymentStatus === "partial_payment" ||
                      effectivePaymentStatus === "pending") &&
                      statusPage !== "cancel" &&
                      statusPage !== "complete" && (
                        <>
                          <Popconfirm
                            title="กำลังจะบันทึกข้อมูลการโอนเงิน"
                            description={
                              <Typography.Text>
                                ระบบจะทำการบันทึกข้อมูลการเงิน
                                <br /> หากถูกต้องแล้วจึงกดปุ่ม "ยืนยัน"
                              </Typography.Text>
                            }
                            okText="ยืนยัน"
                            cancelText="กลับ"
                            onConfirm={() => {
                              setButtonClicked("add_payment");
                              form.submit();
                            }}
                            disabled={
                              item.order_payment_type !== "manual_transfer"
                            }>
                            <Button
                              type="primary"
                              ghost
                              style={{ marginRight: "5px" }}
                              disabled={
                                item.order_payment_type !== "manual_transfer"
                              }>
                              บันทึกการโอนเงิน
                            </Button>
                          </Popconfirm>
                        </>
                      )}

                    {statusPage === "new_order" && (
                      <>
                        <Popconfirm
                          title="กำลังจะส่งรายการไปผลิต "
                          description={
                            (item.final_price || 0) >= 0 ? (
                              <Typography.Text>
                                คุณต้องการส่งรายการสั่งซื้อนี้ไปผลิต ใช่หรือไม่
                              </Typography.Text>
                            ) : (
                              <Typography.Text>
                                กรุณาตรวจสอบเนื่องจากการชำระเงินยังไม่ครบ
                                <br /> คุณต้องการให้เครดิตลูกค้าท่านนี้
                                ใช่หรือไม่
                              </Typography.Text>
                            )
                          }
                          // disabled={
                          //   item.payment_status !== "confirm"
                          // }
                          disabled={codCreditBlocksAccept}
                          okText="ยืนยัน"
                          cancelText="กลับ"
                          onConfirm={() => {
                            setButtonClicked("confirm_order");
                            form.submit();
                            // if (item.order_payment_type === "manual_transfer") {
                            //   form.submit();
                            // } else {
                            //   confirmManualPayment(
                            //     {
                            //       order_id: item.order_id,
                            //       process: "confirm_order",
                            //     },
                            //     {
                            //       onSuccess: (res) => {
                            //         if (res.status === "success") {
                            //           message.success(`ยืนยันคำสั่งซื้อสำเร็จ`);
                            //           refetchData();
                            //           onClose();
                            //           form.resetFields();
                            //           refetchPrepare && refetchPrepare();
                            //           refectShipped && refectShipped();
                            //           setFormValues({});
                            //         } else {
                            //           message.error(
                            //             `ยืนยันคำสั่งซื้อไม่สำเร็จ กรุณาตรวจสอบข้อมูล`
                            //           );
                            //           console.log(res.error_message);
                            //         }
                            //       },
                            //       onError: (error) => {
                            //         message.error(
                            //           `ยืนยันคำสั่งซื้อไม่สำเร็จ กรุณาตรวจสอบข้อมูล`
                            //         );
                            //         console.log(error.message);
                            //       },
                            //     }
                            //   );
                            // }
                          }}>
                          <Button
                            type="primary"
                            // warning
                            style={{ marginRight: "5px" }}
                          // disabled={
                          //   item.payment_status !== "confirm"
                          // }
                            disabled={codCreditBlocksAccept}
                          >
                            ยืนยันคำสั่งซื้อ
                          </Button>
                        </Popconfirm>
                      </>
                    )}

                    {/* {statusPage === "shipped" && (
                      <>
                        <Popconfirm
                          title="บันทึกข้อมูลการจัดส่ง"
                          description={
                            <Typography.Text>
                              คุณต้องการบันทึกข้อมูลการจัดส่ง
                              <br /> หากถูกต้องแล้วจึงกดปุ่ม ยืนยัน
                            </Typography.Text>
                          }
                          okText="ยืนยัน"
                          cancelText="กลับ"
                          onConfirm={() => {
                            if (item.transport_type === "post_office") {
                              formPostal.submit();
                            } else {
                              formTransport.submit();
                            }
                          }}
                        >
                          <Button
                            type="primary"
                            ghost
                            onClick={() => {}}
                            style={{
                              marginRight: "5px",
                            }}
                          >
                            บันทึกข้อมูลการจัดส่ง
                          </Button>
                        </Popconfirm>
                      </>
                    )} */}

                    {/* แถบเตรียมจัดส่ง + ระหว่างจัดส่ง: ปิดงานได้เลยเมื่อลูกค้าได้รับของแล้ว (POST update_order_complete) */}
                    {(statusPage === "shipped" ||
                      statusPage === "prepare_ship") && (
                      <>
                        <Popconfirm
                          title="ยืนยันลูกค้าได้รับสินค้า"
                          description={
                            <Typography.Text>
                              คุณต้องการยืนยันว่าลูกค้าได้รับสินค้าแล้ว
                              <br /> หากถูกต้องแล้วจึงกดปุ่ม ยืนยัน
                            </Typography.Text>
                          }
                          okText="ยืนยัน"
                          cancelText="กลับ"
                          onConfirm={() => {
                            updateOrderComplete(
                              {
                                order_id: item.order_id,
                                memo: memo,
                              },
                              {
                                onSuccess: (res) => {
                                  if (res.status === "success") {
                                    message.success(
                                      "ยืนยัน ลูกค้า ได้รับสินค้าแล้วสำเร็จ"
                                    );
                                    onClose();
                                    refetchData();
                                    refetchPrepare && refetchPrepare();
                                    refectShipped && refectShipped();
                                    // รีเฟรชทุกแท็บ (รวมแท็บสำเร็จ + ตัวเลขบนแท็บ)
                                    queryClient.invalidateQueries({
                                      queryKey: ["orderDataNewOrder"],
                                    });
                                  } else {
                                    message.error(
                                      `ยืนยัน ลูกค้า ได้รับสินค้าแล้วไม่สำเร็จ: ${res.error_message}`
                                    );
                                  }
                                },
                                onError: (error) => {
                                  message.error(
                                    `ยืนยัน ลูกค้า ได้รับสินค้าแล้วไม่สำเร็จ: ${error.message}`
                                  );
                                },
                              }
                            );
                          }}>
                          <Button
                            type="primary"
                            // แถบเตรียมจัดส่ง: ปุ่มหลักคือ "ยืนยันการส่ง" ปุ่มนี้เลยเป็นแบบ ghost
                            ghost={statusPage === "prepare_ship"}
                            onClick={() => { }}
                            style={{ marginRight: "5px" }}>
                            ยืนยันลูกค้าได้รับสินค้าแล้ว
                          </Button>
                        </Popconfirm>
                      </>
                    )}
                    {statusPage === "prepare_ship" && (
                      <>
                        <Popconfirm
                          title="ยืนยันการจัดส่ง"
                          disabled={(use_platform_transport || isAppAgent) && (!isAllTrackingComplete || !isAllTrackingPrinted)}
                          description={
                            <Typography.Text>
                              กรุณาตรวจสอบข้อมูลการจัดส่ง
                              <br /> หากถูกต้องแล้วจึงกดปุ่ม ยืนยันการส่ง
                            </Typography.Text>
                          }
                          okText="ยืนยันจัดส่ง"
                          cancelText="กลับ"
                          onConfirm={() => {
                            if (use_platform_transport || isAppAgent) {
                              confirmOrderShipped(
                                { order_id: item.order_id },
                                {
                                  onSuccess: () => {
                                    message.success("ยืนยันการส่งสำเร็จ");
                                    refetchData();
                                    refectShipped && refectShipped();
                                    onClose();
                                  },
                                  onError: () => message.error("ยืนยันการส่งไม่สำเร็จ"),
                                }
                              );
                            } else if (
                              item.transport_type === "post_office" ||
                              item.transport_type === "taxi"
                            ) {
                              formPostal.submit();
                            } else {
                              formTransport.submit();
                            }
                            // onClose();
                          }}
                        >
                          <Button
                            type="primary"
                            disabled={(use_platform_transport || isAppAgent) && (!isAllTrackingComplete || !isAllTrackingPrinted)}
                            onClick={() => { }}
                            style={{ marginRight: "5px" }}
                          >
                            ยืนยันการส่ง
                          </Button>
                        </Popconfirm>
                      </>
                    )}
                  </>
                </div>
              </div>
            </div>
          </Modal>

          <Modal
            title="แก้ไขวันที่ต้องส่งสินค้า"
            open={due}
            // width={1000}
            maskClosable={false}
            onCancel={() => {
              closeDue();
              formDueDate.resetFields();
            }}
            style={{ top: 20 }}
            cancelText="ปิด"
            okText="ยืนยันการแก้ไขวันที่ต้องส่งสินค้า"
            // okButtonProps={{
            //   style: { backgroundColor: "#ff4d4f", borderColor: "#ff4d4f", color: "white" },
            // }}
            onOk={() => {
              formDueDate.submit();
            }}>
            <Form form={formDueDate} onFinish={onFinishDueDate}>
              <WrapperAll>
                <DueDateOrderDialog
                  form={formDueDate}
                  dueDate={item.due_date}
                />
              </WrapperAll>
            </Form>
          </Modal>

          <Modal
            title="ยกเลิกคำสั่งซื้อ"
            open={cancel}
            // width={1000}
            maskClosable={false}
            onCancel={() => {
              setCancel(false);
              formCancel.resetFields();
            }}
            style={{ top: 20 }}
            cancelText="ปิด"
            okText="ยืนยันการยกเลิกคำสั่งซื้อ"
            okButtonProps={{
              style: {
                backgroundColor: "#ff4d4f",
                borderColor: "#ff4d4f",
                color: "white",
              },
            }}
            onOk={() => {
              formCancel.submit();
            }}>
            <Form form={formCancel} onFinish={onFinishCancel}>
              <WrapperAll>
                <CancelOrderDialog paidStatus={item.payment_status || ""} />
              </WrapperAll>
            </Form>
          </Modal>

          <ModalTaxInvoice
            open={openTax}
            setOpen={setOpenTax}
            item={item.tax_invoice}
          />

          {canSelfTrackInDetail && (
            <SelfTrackingModal
              visible={showSelfTracking}
              orderId={item.order_id}
              selfItems={selfTrackingState?.pendingItems ?? null}
              onClose={() => setShowSelfTracking(false)}
              onSaved={() => {
                refetchData();
                refectShipped?.();
                loadSelfTrackingState();
              }}
            />
          )}
        </div>
      )}
    </>
  );
};

export default ModalOderDetail;

const HeaderTab = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #f0f0f0;
`;

const WrapperAll = styled.div`
  padding: 10px 0px 10px 0px;
`;

const FormWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 10x;
  background-color: #ffffffff;
`;
